import { BaseIcon } from './base';
import type { IconProps } from './base';

export function IconSend(props: IconProps) {
  return (
    <BaseIcon {...props}>
      <path
        d="M20.707 3.293a1 1 0 0 1 .23 1.058l-6 16a1 1 0 0 1-1.856.043l-2.843-6.632-6.632-2.843a1 1 0 0 1 .043-1.855l16-6a1 1 0 0 1 1.058.229Zm-8.521 9.935 1.752 4.089 3.505-9.345-5.257 5.256Zm3.843-6.67-9.346 3.504 4.089 1.752 5.257-5.257Z"
        fill="currentColor"
      />
    </BaseIcon>
  );
}
